import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private httpClient: HttpClient) { }

  api_root: string = environment.REST_API_SERVER;
  stripeUrl = 'dam-payment/';
  stripeCustomPaymentUrl = 'dam-payment/1/custom_plan_payment/';

  public getDamPlans() {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'dam-plans/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getDateCall() {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'contact-sale/1/get_available_date';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['Available_Slots'];
    }));
  }

  public getTimeCall(date: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'contact-sale/1/get_available_slot/?date='+date;
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['Available_Slots'];
    }));
  }

  public contactSalesCallApi(name, email, company, date, time) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'contact-sale/';
    const data = {
      "name": name,
      "email": email,
      "company": company,
      "date": date,
      "time_start": time
    }

    return this.httpClient.post<any>(similar_url, data);
  }

//   stripe_obj = serializers.JSONField()
// amount = serializers.IntegerField()
// currency = serializers.CharField()
// plan_id = serializers.IntegerField()
// name = serializers.CharField()
// line1 = serializers.CharField()
// postal_code = serializers.CharField()
// city = serializers.CharField()
// state = serializers.CharField()
// country = serializers.CharField()

  public postStripeOrder(stripeJson: any, amount: string, currency: string, plan_id: string,
    userName: string, address: string, city: string, state: string, country: string, postcode: string,
    newAmount: string, totalUsers: string, isCustomPlan: boolean, couponCode: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + this.stripeUrl;
    const data = {
      "stripe_obj": stripeJson,
      "amount": newAmount,
      "currency": currency,
      "plan_id": plan_id,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "total-user": totalUsers,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe',
      "coupon_code": couponCode
    }
    return this.httpClient.post<any>(url, data);
  }

  public postStripeOrderAddSeats(stripeJson: any, amount: string, currency: string, plan_id: string,
    userName: string, address: string, city: string, state: string, country: string, postcode: string,
    newAmount: string, totalUsers: string, isCustomPlan: boolean, totalSeats: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/upgrade_seats/";
    const data = {
      "stripe_obj": stripeJson,
      "amount": amount,
      "currency": currency,
      "plan_id": plan_id,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "total-user": totalUsers,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe',
      "seats": totalSeats
    }
    return this.httpClient.post<any>(url, data);
  }

  public postStripeOrderAddAdminSeats(stripeJson: any, amount: string, currency: string, plan_id: string,
    userName: string, address: string, city: string, state: string, country: string, postcode: string,
    newAmount: string, totalUsers: string, isCustomPlan: boolean, totalSeats: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/upgrade_admin_seats/";
    const data = {
      "stripe_obj": stripeJson,
      "amount": amount,
      "currency": currency,
      "plan_id": plan_id,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe',
      "admin_seats": totalSeats
    }
    return this.httpClient.post<any>(url, data);
  }

  public postStripeOrderPlanUpgrade(stripeJson: any, amount: string, currency: string, plan_id: string,
    userName: string, address: string, city: string, state: string, country: string, postcode: string,
    newAmount: string, totalUsers: string, isCustomPlan: boolean, targetPlanid: any) {
    const api_root = environment.REST_API_SERVER;
    // console.log(amount +" - "+currency +" - "+plan_id +" - "+plan_text)
    let url = api_root + this.stripeUrl;
    const data = {
      "stripe_obj": stripeJson,
      "amount": amount,
      "currency": currency,
      "plan_id": plan_id,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "total-user": totalUsers,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe',
      "target_plan_id": targetPlanid
    }
    return this.httpClient.post<any>(url, data);
  }

  public postStripeOrderPlanUpgradeProRata(stripeJson: any, amount: string, currency: string, plan_id: string,
    userName: string, address: string, city: string, state: string, country: string, postcode: string,
    newAmount: string, totalUsers: string, isCustomPlan: boolean, targetPlanid: any, newSeats: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/upgrade_plan_prorata/";
    const data = {
      "stripe_obj": stripeJson,
      "amount": amount,
      "currency": currency,
      "plan_id": plan_id,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "total-user": totalUsers,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe',
      "target_plan_id": targetPlanid,
      "new_extra_seat": newSeats
    }
    return this.httpClient.post<any>(url, data);
  }

  public getUpgradePlanDetails(planId: any) {
    this.api_root = environment.REST_API_SERVER;
    let query_params: string = '';
    let similar_url = this.api_root + 'dam-payment/1/get_plan_upgrade_amount/';
    if (planId) { query_params += "target_plan_id=" + planId };
    if (query_params) {
      similar_url += '?' + query_params;
    }
    return this.httpClient.get<any>(similar_url);
  }

  public getUpgradePlanDetailsRazor(planId: any) {
    this.api_root = environment.REST_API_SERVER;
    let query_params: string = '';
    let similar_url = this.api_root + 'dam-payment/1/get_plan_upgrade_amount_razor/';
    if (planId) { query_params += "target_plan_id=" + planId };
    if (query_params) {
      similar_url += '?' + query_params;
    }
    return this.httpClient.get<any>(similar_url);
  }

  public getRazorOrderId(name: string, amount: string, currency: string,
    planId: string, isCustomPlan: boolean, totalUser: string, couponcode: string) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/get_razor_data/";
    const data = {
      "name": name,
      "amount": amount,
      "currency": "USD",
      "plan_id": planId,
      "is-custom-plan": isCustomPlan,
      "total-user": totalUser,
      "coupon_code": couponcode
    }
    return this.httpClient.post<any>(url, data);
  }

  public payRazorAmountOrderId(razorpayPaymentId: string,razorpayOrderId: string, razorpaySignature: string,
    userName: string, planId: any, totalValue: any, totalSeats: any, isCustomPlan: boolean, couponCode: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/pay_razor/";
    const data = {
      "razorpay_payment_id": razorpayPaymentId,
      "razorpay_order_id": razorpayOrderId,
      "razorpay_signature": razorpaySignature,
      "name": userName,
      "amount": totalValue,
      "currency": "USD",
      "plan_id": planId,
      "is-custom-plan": isCustomPlan,
      "total-user": totalSeats,
      "coupon_code": couponCode
    }
    return this.httpClient.post<any>(url, data);
  }

  public getEnterpriseCustomPlanRazorOrderId(name: string, amount: string, currency: string,
    isCustomPlan: boolean, totalUser: string, couponcode: string, paymentId: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/get_custom_plan_amount_razor/?payment_id="+paymentId
    const data = {
      "name": name,
      "amount": amount,
      "currency": "USD",
      "is-custom-plan": isCustomPlan,
      "total-user": totalUser,
      "coupon_code": couponcode,
    }
    return this.httpClient.post<any>(url, data);
  }

  public getEnterpriseCustomOfferPlanRazorOrderId(name: string, amount: string,
    isCustomPlan: boolean, totalUser: string, couponcode: string, dialog_id: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/get_dialog_plan_amount_razor/?dialog_id="+dialog_id
    const data = {
      "name": name,
      "amount": amount,
      "currency": "USD",
      "is-custom-plan": isCustomPlan,
      "total-user": totalUser,
      "coupon_code": couponcode,
    }
    return this.httpClient.post<any>(url, data);
  }

  public payEnterpriseCustomPlanRazorAmountOrderId(razorpayPaymentId: string,razorpayOrderId: string, razorpaySignature: string,
    userName: string, totalValue: any, totalSeats: any, isCustomPlan: boolean, couponCode: any, paymentId: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/custom_plan_payment_razor/";
    const data = {
      "razorpay_payment_id": razorpayPaymentId,
      "razorpay_order_id": razorpayOrderId,
      "razorpay_signature": razorpaySignature,
      "name": userName,
      "amount": totalValue,
      "currency": "USD",
      "is-custom-plan": isCustomPlan,
      "total-user": totalSeats,
      "coupon_code": couponCode,
      "payment_id": paymentId
    }
    return this.httpClient.post<any>(url, data);
  }

  public payEnterpriseCustomOfferPlanRazorAmountOrderId(razorpayPaymentId: string,razorpayOrderId: string, razorpaySignature: string,
    userName: string, totalValue: any, totalSeats: any, isCustomPlan: boolean, couponCode: any, dialogId: any) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/pay_razor_dialog/";
    const data = {
      "razorpay_payment_id": razorpayPaymentId,
      "razorpay_order_id": razorpayOrderId,
      "razorpay_signature": razorpaySignature,
      "name": userName,
      "amount": totalValue,
      "currency": "USD",
      "is-custom-plan": isCustomPlan,
      "total-user": totalSeats,
      "coupon_code": couponCode,
      "dialog_id": dialogId,
      "plan_id": "1",
    }
    return this.httpClient.post<any>(url, data);
  }

  public postRazorOrderPlanUpgradeProRata(amount: string, currency: string, plan_id: string,
    userName: string, address: string, city: string, state: string, country: string, postcode: string,
    newAmount: string, totalUsers: string, isCustomPlan: boolean, targetPlanid: any, newSeats: any,
    razorpayPaymentId: string, razorpayOrderId: string, razorpaySignature: string) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/upgrade_plan_prorata_razor/";
    const data = {
      "amount": amount,
      "currency": currency,
      "plan_id": plan_id,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "total-user": totalUsers,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe',
      "target_plan_id": targetPlanid,
      "new_extra_seat": newSeats,
      "razorpay_payment_id": razorpayPaymentId,
      "razorpay_order_id": razorpayOrderId,
      "razorpay_signature": razorpaySignature,
    }
    return this.httpClient.post<any>(url, data);
  }

  public postRazorOrderAddSeats(userName: string, amount: string, currency: string, plan_id: string,
    totalSeats: any, razorpayPaymentId: string, razorpayOrderId: string, razorpaySignature: string) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/upgrade_seats_razor/";
    const data = {
      "plan_id": plan_id,
      "seats": totalSeats,
      "razorpay_payment_id": razorpayPaymentId,
      "razorpay_order_id": razorpayOrderId,
      "razorpay_signature": razorpaySignature,
      "name": userName,
      "amount": amount,
      "currency": currency,
    }
    return this.httpClient.post<any>(url, data);
  }

  public postRazorOrderAddAdminSeats(userName: string, amount: string, currency: string, plan_id: string,
    totalSeats: any, razorpayPaymentId: string, razorpayOrderId: string, razorpaySignature: string) {
    const api_root = environment.REST_API_SERVER;
    let url = api_root + "dam-payment/1/upgrade_admin_seats_razor/";
    const data = {
      "plan_id": plan_id,
      "admin_seats": totalSeats,
      "name": userName,
      "currency": currency,
      "razorpay_payment_id": razorpayPaymentId,
      "razorpay_order_id": razorpayOrderId,
      "razorpay_signature": razorpaySignature,
      "amount": amount,
    }
    return this.httpClient.post<any>(url, data);
  }

  public shareAssetsSettingsData (token: any, allowDownloads: any, expireLink: any,
    showComments: any, allowComments: any) {
      this.api_root = environment.REST_API_SERVER;
      let url = this.api_root + 'shared/' + token + '/set_asset_shared_configuration/';
      const data = {
        "allow_downloads": allowDownloads,
        "expire_link": expireLink,
        "show_comments": showComments,
        "allow_comments": allowComments
      }
      return this.httpClient.post<any>(url, data);
  }

  public shareBoardsSettingsData (token: any, allowDownloads: any, expireLink: any,
    showComments: any, allowComments: any) {
      this.api_root = environment.REST_API_SERVER;
      let url = this.api_root + 'shared/' + token + '/set_board_shared_configuration/';
      const data = {
        "allow_downloads": allowDownloads,
        "expire_link": expireLink,
        "show_comments": showComments,
        "allow_comments": allowComments
      }
      return this.httpClient.post<any>(url, data);
  }

  public hitShare(workspaceId: any, boardId: any, imgId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/[' + imgId + ']-2-0/share_assets/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public hitMultipleShare(workspaceId: any, boardId: any, imgId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/[' + imgId + ']-2-0/share_assets/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public hitBoardShare(workspaceId: any, boardId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/['+ boardId + ']-2-0/share_board/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public pluginResolution(workspaceId: any, allWorkspace: any, allBoard: any, percentageAsset: any, boardList: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/set_asset_quality_settings/';
    const data = {
      "is_all_workspace_quality": allWorkspace,
      "is_all_board_quality": allBoard,
      "asset_quality_percentage": percentageAsset,
      "quality_board_list": '['+ boardList + ']',
    }
    return this.httpClient.post<any>(url, data);
  }

  public getPluginResolution(workspaceId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/get_asset_quality_settings/';
    return this.httpClient.get<any>(url);
  }

  public sendStackingCoupons(couponCode: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/upgrade_plan_coupon/';
    const data = {
      "coupon_code": couponCode,
      "coupon_from": "appsumo",
    }
    return this.httpClient.post<any>(url, data);
  }

  public postStripeOrderCustomPayment(stripeJson: any, amount: string, currency: string, plan_id: string,
    userName: string, address: string, city: string, state: string, country: string, postcode: string,
    newAmount: string, totalUsers: string, isCustomPlan: boolean, paymentId: any) {
    const api_root = environment.REST_API_SERVER;
    // console.log(amount +" - "+currency +" - "+plan_id +" - "+plan_text)
    let url = api_root + this.stripeCustomPaymentUrl;
    const data = {
      "stripe_obj": stripeJson,
      "amount": newAmount,
      "currency": currency,
      "plan_id": plan_id,
      "name": userName,
      "line1": address,
      "city": city,
      "state": state,
      "country": country,
      "postal_code": postcode,
      "new-amount": newAmount,
      "total-user": totalUsers,
      "is-custom-plan": isCustomPlan,
      "order_from": 'stripe',
      "payment_id": paymentId
    }
    return this.httpClient.post<any>(url, data);
  }
}
